import React from 'react';
import { List } from '@mui/material';
import { AccordionWrapper } from '../Layouts/StyledComponentsMenu';
import { AccordionItem } from './AccordionItem';
import { MiniDrawerItem } from './MiniDrawerItem';

export const AccordionMenuComponent = ({
  open,
  menuItems,
  expanded,
  handleAccordionChange,
  handleNavigate,
  handleClick,
  handleClose,
  openMenu,
  anchorEl,
  setAnchorEl,
  navigate,
  handleNavigateWallet,
  activeItem,
  setActiveItem,
}) => {
  return (
    <AccordionWrapper>
      <List sx={{ mb: open ? '0px' : '6px' }}>
        {menuItems.length > 0 &&
          menuItems.map(menuItem =>
            open ? (
              <AccordionItem
                open={open}
                key={menuItem.id}
                menuItem={menuItem}
                expanded={expanded}
                handleAccordionChange={handleAccordionChange}
                handleNavigate={handleNavigate}
                handleNavigateWallet={handleNavigateWallet}
                activeItem={activeItem}
                setActiveItem={setActiveItem}
              />
            ) : (
              <MiniDrawerItem
                key={menuItem.id}
                open={open}
                menuItem={menuItem}
                handleClick={handleClick}
                handleClose={handleClose}
                openMenu={openMenu}
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                navigate={navigate}
                handleNavigateWallet={handleNavigateWallet}
                activeItem={activeItem}
                setActiveItem={setActiveItem}
              />
            ),
          )}
      </List>
    </AccordionWrapper>
  );
};
